export function defaultProcessSteps() {
  return [
    { titleZh: '接收', titleEn: 'Intake', bodyZh: '持续查看门户提交与加密邮件。', bodyEn: 'We continuously watch portal reports and encrypted email.' },
    { titleZh: '验证', titleEn: 'Verify', bodyZh: '确认问题是否有效及潜在影响。', bodyEn: 'We confirm whether the issue is valid and assess impact.' },
    { titleZh: '修复', titleEn: 'Remediate', bodyZh: '制定修复或缓解并验证有效。', bodyEn: 'We prepare a fix or mitigation and verify it works.' },
    { titleZh: '范围', titleEn: 'Scope', bodyZh: '排查可能受影响的产品与版本。', bodyEn: 'We identify products and versions that may be affected.' },
    { titleZh: '公开', titleEn: 'Publish', bodyZh: '流程完成后审核并发布已协调通告。', bodyEn: 'After the process completes we review and publish a coordinated advisory.' }
  ]
}

const POLICY_DEFAULTS = {
  mailChecklist: {
    zh: '联系方式或组织名称\n受影响产品与版本\n问题描述\n复现或利用方式（纯文本）\n计划公开时间（如有）',
    en: 'Contact or organization\nAffected product and version\nIssue description\nReproduction or exploit steps (plain text)\nPlanned public date if any'
  },
  researchRules: {
    zh: '不得修改或销毁数据\n不得实施拒绝服务或导致服务降级\n不得对外披露个人数据、商业秘密或未公开漏洞细节',
    en: 'Do not modify or destroy data\nDo not cause denial of service or service degradation\nDo not disclose personal data, trade secrets, or unpublished vulnerability details'
  },
  commExpect: {
    zh: '门户提交成功后只返回跟踪编号，不提供进度查询。后续沟通请使用加密邮件，并在主题中保留 XTVD- 编号。我们不发送自动站内信。',
    en: 'A successful portal report returns a tracking ID only. This site does not provide status lookup. Follow up by encrypted email and keep the XTVD- ID in the subject. We do not send automated in-site messages.'
  },
  preDisclosure: {
    zh: '正式通告发布前，请对漏洞细节保密。公开门户只展示已发布通告中的内容。',
    en: 'Please keep vulnerability details confidential until an official advisory is published. This portal only shows published advisories.'
  },
  timelineCaveat: {
    zh: '披露时限可能因修复上线、影响评估或协调安排而调整。',
    en: 'Disclosure timing may change based on fix rollout, impact review, or coordination.'
  },
  conflict: {
    zh: '报告与公开过程中如出现分歧，以本门户披露说明及双方书面确认的协调安排为准。',
    en: 'If disagreement arises during reporting or disclosure, this policy and any written coordination between the parties apply.'
  }
}

export function defaultPolicyField(name, locale) {
  const item = POLICY_DEFAULTS[name]
  if (!item) {
    return ''
  }
  return locale === 'en' ? item.en : item.zh
}
